import { createContext } from "react";

export interface CarouselContextValue {
  previous: () => void;
  next: () => void;
  index: number;
  maxIndex: number;
  visible: number;
}

export const CarouselContext = createContext<CarouselContextValue>({
  previous: () => {},
  next: () => {},
  index: 0,
  maxIndex: 0,
  visible: 0,
});
